/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'filter': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M12 12l8-8V0H0v4l8 8v8l4-4v-4z"/>'
  }
})
